<template>
  <div class="formLogin">
    <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
      <a-form-model-item prop="username">
        <a-input size="large" v-model="ruleForm.username" placeholder="账号" allowClear />
      </a-form-model-item>
      <div class="captcha">
        <a-form-model-item prop="captcha">
          <!-- v-if="this.canOperate(['ForgetPassword'])" -->
          <a-input size="large" v-model="ruleForm.password" type="password" placeholder="密码" allowClear>
            <a-button slot="addonAfter" @click="goResetPsw" class="captchaButton"
              ><span class="forget-pwd">忘记密码?</span>
            </a-button>
          </a-input>
        </a-form-model-item>
      </div>
      <Environment />
     <Vcode :show="errVcode" @success="successVcode" @close="closeVcode" />
      <a-button class="button" @click="submitForm" :loading="btnLoading">登&nbsp;录</a-button>
    </a-form-model>
  </div>
</template>

<script>
import Vcode from 'vue-puzzle-vcode';

import { message } from 'ant-design-vue';
import api from '@/api';
import { post } from '@/utils/http';
import { pwdPublicKeyEncode } from '@/utils/RSAUtils';
// eslint-disable-next-line import/no-unresolved, no-unused-vars
import { canOperate } from '@/utils/utils';
import ErrorLogin from '@/utils/errorLogin';
import Environment from '../environment.vue';
import {
  setToken,
  rmToken,
} from '../../login-handler';

// eslint-disable-next-line import/order
import { pointTools,traceClick } from '@/utils/point';
// import ForgetPassword from './forgetPassword.vue';

export default {
  name: 'UserNameLogin',
  components: {
    Environment,
    Vcode,
  },
  props:['agree'],
  data() {
    return {
      autosize: {
        minRows: 12, maxRows: 6,
      },
      btnLoading: false,
      ruleForm: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      errlg: null,
      errVcode: false,
    };
  },
  mounted() {
    // if (localStorage.getItem('name')) {
    //   this.ruleForm.username = localStorage.getItem('name');
    // }
    this.errlg = new ErrorLogin();
  },
  methods: {
    successVcode() {
      this.errVcode = false;
      this.errlg.refreshPasWord(1);
    },
    closeVcode() {
      // this.errVcode = false;
    },
    canOperate(codes) {
      this.$store.commit('resetStatus', '0');
      return canOperate(codes);
    },
    // 登录操作
    submitForm() {
      // v-if="canOperate(['ForgetPassword'])"
      traceClick(
        {
          event_type: "web_click",
          content: {
            event_id: "auth_login_account_password_click",
            event_name: "登录 - 用户名密码",
          },
        },
        true
      );
      if (this.agree != true) {
        message.error("请勾选确认已经阅读并同意以下协议!");
        return;
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (!this.errlg.voidCodeLogin(1)) {
            this.errVcode = true;
            return;
          }
          rmToken(); // 清除 token
          this.btnLoading = true;
          // eslint-disable-next-line prefer-const
          let password = await pwdPublicKeyEncode(this.ruleForm.password);
          const params = {
            name: this.ruleForm.username,
            // eslint-disable-next-line object-shorthand
            password: password,
          };
          const loginRes = await post(api.internetLoginPwd, params).catch(() => {
            // message.error('登录失败');
            this.errlg.addErrorName();
          });
          this.btnLoading = false;
          if (loginRes && loginRes.token) {
            message.success('登录成功');
            // 获取用户信息需要token 所以先对登录信息进行缓存
            setToken(loginRes);
            this.errlg.refreshPasWord(1);
            this.$emit('getLoginAccount', loginRes);
          }
        }
      });
    },
    goResetPsw() {
      this.$store.commit('switchLogin', '1');
    },
  },
};
</script>

<style lang="less">
.forget-pwd {
  font-size: 16px;
  font-weight: 400;
  color: #999999;
}
</style>
